// @flow

import React, { Fragment } from "react";
import { Grid, Thumbnail, Col, Image } from "react-bootstrap";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

export class Gallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false
    };
  }
  render() {
    const { isOpen, photoIndex } = this.state;
    const { images } = this.props;

    const thumbnailStyle = {
      position: "absolute",
      left: "-1000%",
      right: "-1000%",
      top: "-1000%",
      bottom: "-1000%",
      margin: "auto",
      minHeight: "100%",
      minWidth: "100%"
    };

    const thumbnails = images.map((image, index) => {
      return (
        <Col key={image + index} xs={6} md={3}>
          <div
            style={{
              maxWidth: "250px",
              height: "200px",
              overflow: "hidden",
              margin: "10px",
              position: "relative"
            }}
          >
            <Thumbnail
              href="#"
              alt="171x180"
              src={image}
              style={{ height: "100%" }}
              onClick={() => this.setState({ isOpen: true, photoIndex: index })}
            />
          </div>

          {/* <Image src={image} thumbnail fluid style={{ height: "200px" }} onClick={() => this.setState({ isOpen: true, photoIndex: index })} /> */}
          {/* <img style={{ maxWidth: "100%" }} src={image} /> */}
        </Col>
      );
    });

    const gallery = <Grid>{thumbnails}</Grid>;

    return (
      <Fragment>
        <div style={{ width: "100%", height: "30px" }} />
        {gallery}
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Gallery.js